exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity .5s;\n  transition: opacity .5s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n.accordion .accordion-body {\n  overflow: hidden;\n  -webkit-transition: 150ms ease-out;\n  transition: 150ms ease-out;\n}\n.accordion .accordion-body-inner {\n  overflow-wrap: break-word;\n}\n.accordion-header:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54a914b3","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/FormAccordionV2.vue
// module id = 1555
// module chunks = 2